import React from "react";
import Spinner from "react-spinkit";

const MSpinner = () => {
    return (
        <div className="md-block-centered md-progress mspinner">
            <Spinner name="folding-cube"/>
        </div>
    );
};

export default MSpinner;
